import { useEffect, useState } from "react";

const EMPTY_OFFERS_RETRY_DELAY_MS = 500;
const MAX_EMPTY_OFFERS_RETRIES = 3;

function useRetriedEmptyOffers({
  applicationState,
  hasOffers,
  isError,
  isFetching,
  isLoading,
  refetch,
}: {
  applicationState?: string;
  hasOffers: boolean;
  isError: boolean;
  isFetching: boolean;
  isLoading: boolean;
  refetch: () => Promise<unknown>;
}) {
  const [retryCount, setRetryCount] = useState(0);

  const shouldRetryEmptyOffers = applicationState === "offers_generated" && !hasOffers && !isError;

  useEffect(() => {
    if (!shouldRetryEmptyOffers) {
      setRetryCount(0);
    }
  }, [shouldRetryEmptyOffers]);

  useEffect(() => {
    if (
      !shouldRetryEmptyOffers ||
      isLoading ||
      isFetching ||
      retryCount >= MAX_EMPTY_OFFERS_RETRIES
    ) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setRetryCount((currentCount) => currentCount + 1);
      void refetch();
    }, EMPTY_OFFERS_RETRY_DELAY_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isFetching, isLoading, refetch, retryCount, shouldRetryEmptyOffers]);

  return {
    isWaitingForOffers:
      shouldRetryEmptyOffers && (isLoading || isFetching || retryCount < MAX_EMPTY_OFFERS_RETRIES),
  };
}

export { useRetriedEmptyOffers };
